import { t } from 'i18next'

import type { HoldingDto } from '@hcr/api/consumer'
import { UNICODE } from '@hcr/ui'

type CreateHoldingNameStringOptions = Pick<HoldingDto, 'room_number' | 'room_size'>

export const createHoldingNameString = ({ room_number, room_size }: CreateHoldingNameStringOptions): string =>
  `${t('utils.holding-apartment')} ${room_number}, ${room_size}m${UNICODE.superscriptTwo}`
